<template>
<div class="section_b_">
    <ul class="tabs_">
        <li v-for="(item, index) in tabs" @click="handleTabChange(index)"
            :class="tabType == index ? 'active_' : ''" 
            class="item_">{{item}}</li>
    </ul>
    <div v-if="tabType == 0" class="content_" style="overflow:hidden">
*最高入保年龄为64周岁，续保最高年龄至70周岁。
*年度人民币保费直付方式需为一次付清。
*等待期：新保员工，住院30天等待期（意外情况可豁免等待期）转保可取消等待期。
<font color="red">*该方案适用于5-20名（不包括20）员工（员工是指与投保单位有实质性的劳务雇佣关系的人员，不包含员工的附属被保险人；我们保留要求投保单位提供雇佣关系证明的权利）以下的团体，若员工人数超过20人的团体需提供历史赔付数据，历史赔付不超过80%的团体仍可使用该费率。</font>
*该方案整个保险年度内， 主被保险人以及附属被保险人须居住在中国大陆、香港、澳门或台湾地区至少达 2/3以上的时间（8 个月）；如果不能满足以上条件，报价可能会有调整。
*对于可选生育、体检、 牙科、眼科保障，所有参保人员必须同一时间选择同一福利套餐入保及续保。其中可选生育责任需满足主被保险人6人及6人以上的团体投保。
*主被保险人的配偶或子女（投保时应未满 21 岁；为全日制在校学生的，年龄应未满 26 岁）可作为本合同的附属被保险人。
*如果有附属被保险人，须与主被保险人同时入保并且选择同种保障，家庭情况变更时例外。
*保险年度中，如主被保险人家属的保险保障需进行变更（如新婚和新生婴儿等）， 须在前述改变发生之日起 30 天内书面申请加保，超出时限则需医疗核保。
*如遇员工离职，该员工的最后一个工作日即为保险终止日，保费将会按天折算。
*公司所有符合入保条件的全职员工均必须加入本计划。
*20名员工及以下团体需全面医学核保（需全员提供个人健康告知），20名员工以上团体可承担一般既往症，除外重大既往症条件承保。5-20名员工的团体若承担一般既往症，除外重大既往症条件承保，健康险部分需加费40%。

其中重大既往症是指：
（1）心血管疾病 - 包括冠心病、 先天性心脏病、 心肌梗塞、 主动脉瘤；
（2）神经疾病 - 包括脑卒中、脑动脉瘤、阿尔茨海默病、帕金森病、脊髓空洞症、多发性硬化症；
（3）血液疾病－包括白血病、 淋巴瘤、 再生障碍性贫血、 血小板减少性紫癜、 血友病；
（4）肺部疾病－慢性阻塞性肺病、 原发性肺动脉高压；
（5）消化疾病－肝硬化、 重症肝炎；
（6）自身免疫性疾病－包括系统性红斑狼疮、 系统性硬皮病，获得性免疫缺陷综合症（AIDS，艾滋病）、艾滋相关综合征（ARCS）和其他与 HIV 病毒相关的性传染病或者症状；
（7）其他 - 恶性肿瘤、良性脑肿瘤、良性脊髓肿瘤、主要器官衰竭或者移植、囊性纤维化、黑斑息肉病、Ⅲ度烧伤。

组合计划：
1、5名员工及以下团体最多可投保一个计划保障方案；
2、6-10名员工的团体最多可投保两个计划保障方案；
3、超过10名员工的团体最多可投保三个计划保障方案；
4、同一个团体选择多个保障计划，需要有明确、客观的参保等级划分（如参照职级、工作岗位、主被保险人或附属被保险人等）。

上述保障方案与报价，应与《团体条款》一起解读、理解，本报价未涉及部分，以保险条款为准。
    </div>
    <div class="content_" v-else-if="tabType == 1">
        <ul class="steps_wrap_">
            <li class="item_">
                <img class="img_" src="~@/assets/quote/2.png">
                1、提供投保信息
            </li>
            <li class="item_">
                <img src="~@/assets/quote/3.png" class="img_">
                2、提供人员清单
            </li>
            <li class="item_">
                <img src="~@/assets/quote/2.png" class="img_">
                3、提交投保成功
            </li>
            <li class="item_">
                <img src="~@/assets/quote/2.png" class="img_">
                4、支付保费
            </li>
        </ul>
    </div>
    <div class="content_" v-else style="overflow:hidden">
        <iframe width=100% height=100%  frameborder=0 scrolling=auto src="https://midesk.ssish.com/visitor/material/materialDetail/pt_n6-fPEI2PzBG5zctW-Q==" mce_src="URL"></iframe>
        <!-- <table class="table_" style="width: 100%;" border>
            <tr><td style="text-align:center;font-weight:bold;">中国大陆</td></tr>
            <tr>
                <td>和睦家所有医院或诊所</td>
            </tr>
            <tr>
                <td>莱佛士医疗北京/深圳/天津/天津泰达/南京/大连诊所（南京、天津、天津泰达、深圳国际（SOS）紧急救援诊所；北京国际（SOS）救援中心、大连安慎诊所）</td>
            </tr>
            <tr>
                <td>百汇医疗集团旗下医疗机构（除香港和成都鹰阁外的其它城市；除百汇馨康品牌旗下的医疗机构）</td>
            </tr>
            <tr>
                <td>上海国际医学中心</td>
            </tr>
            <tr>
                <td>上海全康医疗中心/上海众康门诊部</td>
            </tr>
            <tr>
                <td>上海东方联合医院</td>
            </tr>
            <tr>
                <td>上海红枫国际妇儿医院 </td>
            </tr>
            <tr>
                <td style="text-align:center;font-weight:bold;">香港</td>
            </tr>
            <tr>
                <td>港安医院</td>
            </tr>
            <tr>
                <td>香港明德医院</td>
            </tr>
            <tr>
                <td>香港养和医院</td>
            </tr>
            <tr>
                <td style="text-align:center;font-weight:bold;">新加坡</td>
            </tr>
            <tr>
                <td>伊丽莎白医院（新加坡）</td>
            </tr>
            <tr>
                <td>鹰阁医院（新加坡）</td>
            </tr>
            <tr>
                <td>伊丽莎白诺维娜医院（新加坡）</td>
            </tr>
        </table> -->
    </div>
</div>
</template>
<style lang="scss" scoped>
    .section_b_ {
        margin-top: 12px;
        border: 1px solid #eee;
        .table_ {
            width: 100%;
            table-layout: fixed;
            white-space: normal;
            border: 1px solid #eee;
            margin-bottom: 32px;
            td {
                padding: 6px;
            }
        }
        .steps_wrap_ {
            margin-left: 30px;
            padding-left: 60px;
            white-space: nowrap;
            border-left: 1px solid #6284fe;
            .item_ {
                position: relative;
                margin-bottom: 60px;
                color: #333;
                font-weight: bold;
                font-size: 18px;
                line-height: 68px;
            }
            .img_ {
                width: 68px;
                height: auto;
                position: absolute;
                left: -96px;
            }
        }
        .content_ {
            height: auto;
            min-height: 600px;
            overflow-y: auto;
            white-space: pre-wrap;
            padding: 0 12px;
        }
        .tabs_ {
            display: flex;
            border-bottom: 1px solid #eee;
            line-height: 52px;
            text-align: center;
            .item_ {
                flex: 1;
                &.active_ {
                    border-bottom: 1px solid rgb(61, 94, 213);;
                }
            }
        }
    }
</style>
<script>
export default {
    data () {
        return {
            tabs: ['投保须知', '投保流程', '昂贵医院列表'],
            tabType: 0
        }
    },
    methods: {
        handleTabChange(index) {
            this.tabType = index;
        }
    }
}
</script>